import React, {PropsWithChildren, useEffect} from "react";
import Loader from "../components/core/Loader";
import BackendRestClient from "../api/BackendRestClient";
import BackendRestClientWithoutHeaders from "../api/BackendRestClientWithoutHeaders";
import {useSnackbar} from 'notistack';

export const AppContext = React.createContext({});


function setupRestClient(configuration, enqueueSnackbar) {

    BackendRestClient.interceptors.request.use(config => {
        config.baseURL = configuration.url.backend;
        return config;
    }, error => Promise.reject(error));

    BackendRestClientWithoutHeaders.interceptors.request.use(config => {
        config.baseURL = configuration.url.backend;
        return config;
    }, error => Promise.reject(error));


    BackendRestClient.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        console.error(error.response);
        console.error(error.request);
        enqueueSnackbar("Server Error. Please refresh page and try again", {
            variant: "error",
            preventDuplicate: true
        });
        return Promise.reject(error);
    });

    BackendRestClientWithoutHeaders.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        console.error(error.response);
        console.error(error.request);
        enqueueSnackbar("Server Error. Please refresh page and try again", {
            variant: "error",
            preventDuplicate: true
        });
        return Promise.reject(error);
    });


}

export const AppContextProvider: React.FC<PropsWithChildren> = ({children}) => {

    const {enqueueSnackbar} = useSnackbar();

    const [config, setConfig] = React.useState({
        backendUrl: ''
    });


    useEffect(() => {
        const fetchData = async () => {
            let response = await fetch('/etc/system.conf');

            let configuration = await response.json();

            setupRestClient(configuration, enqueueSnackbar);
            setConfig({backendUrl: configuration.url.backend});


        };
        fetchData();
    }, [setConfig, enqueueSnackbar]);


    if (!config.backendUrl) {
        return <Loader/>;
    }

    console.log("Config Context: " + JSON.stringify(config, null, " "));
    fun();

    return <AppContext.Provider value={{
        config
    }}>
        {children}
    </AppContext.Provider>
};


function fun() {
    const style1 = [
        'color: powderBlue',
        'text-shadow: 2px 2px purple',
        'background: plum',
        'font-size: 3em',
        'border: 1px solid purple',
        'padding: 20px',
        'font-family: fantasy'
    ];


    if (window && window.location && window.location.origin && !window.location.origin.includes("localhost") && window.location.origin.includes("test")) {
        console.log('%cIt is important to have fun at work', style1.join(';'));
        console.log('%c' + window.location.origin + "/fun", 'font-size: 2em; color: red');
    }
}
